import { StyleSheet } from '@react-pdf/renderer';

// Defaults del engine (fallback si el tenant no setea colores).
// Nota: el primary default aquí (#0055b3) matchea el theme UI, distinto al
// verde legacy (#548235) que se usaba antes del sistema tenant colors.
const DEFAULT_COLORS = {
  primary: '#0055b3',
  secondary: '#c5561d',
  darkText: '#2c3e50',
  bodyText: '#34495e',
  muted: '#7f8c8d',
  lightBg: '#f8f9fa',
  border: '#e8e8e8',
  white: '#ffffff',
};

// Factory que combina los defaults con los colores del tenant recibidos.
export const getTemplateColors = ({ primary, secondary } = {}) => ({
  ...DEFAULT_COLORS,
  primary: primary ?? DEFAULT_COLORS.primary,
  secondary: secondary ?? DEFAULT_COLORS.secondary,
});

export const FONT = {
  base: 'Helvetica',
  bold: 'Helvetica-Bold',
};

// Factory de estilos base parametrizados por los colores del tenant.
// Se consume desde TemplateColorsContext, que lo memoiza por colors.
export const makeBaseStyles = (colors) =>
  StyleSheet.create({
    page: {
      backgroundColor: colors.white,
      fontFamily: FONT.base,
      paddingTop: '3cm',
      paddingBottom: '3cm',
      paddingHorizontal: '1.5cm',
    },
    body: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.6cm',
    },
    sectionTitle: {
      fontSize: 11,
      fontFamily: FONT.bold,
      color: colors.primary,
      textTransform: 'uppercase',
      marginBottom: '0.2cm',
      borderBottom: `1px solid ${colors.primary}`,
      paddingBottom: '0.1cm',
    },
  });

// Exports legacy (backward compat): COLORS y baseStyles constantes con los
// defaults. NO se usan más dentro del engine (consume el context), pero se
// conservan por si algún archivo fuera del engine los importa.
export const COLORS = DEFAULT_COLORS;
export const baseStyles = makeBaseStyles(DEFAULT_COLORS);
